import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { availabilityApi } from '../api/availabilityApi';
import { CreateBookingAvailabilityDto, UpdateBookingAvailabilityDto } from '../types/booking';

const QUERY_OPTIONS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 60 * 1000,
} as const;

const QUERY_KEYS = {
  availability: ['booking-availability'],
};

export const useAvailability = () =>
  useQuery({
    queryKey: QUERY_KEYS.availability,
    queryFn: () => availabilityApi.getAvailability().then((res) => res.data),
    ...QUERY_OPTIONS,
  });

export const useCreateSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateBookingAvailabilityDto) => availabilityApi.createSchedule(data).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.availability });
      toast.success('Schedule created successfully');
    },
    onError: () => toast.error('Failed to create schedule'),
  });
};

export const useUpdateSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateBookingAvailabilityDto }) => availabilityApi.updateSchedule(id, data).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.availability });
      toast.success('Schedule updated successfully');
    },
    onError: () => toast.error('Failed to update schedule'),
  });
};

export const useDeleteSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => availabilityApi.deleteSchedule(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.availability });
      toast.success('Schedule deleted successfully');
    },
    onError: () => toast.error('Failed to delete schedule'),
  });
};

// No dedicated toggle endpoint exists; toggling is a full update with isAvailable flipped.
export const useToggleScheduleActive = () => useUpdateSchedule();

//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) => availabilityApi.toggleActive(id, isActive).then((res) => res.data),
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: QUERY_KEYS.availability });
//       toast.success('Schedule updated');
//     },
//     onError: () => toast.error('Failed to update schedule'),
//   });
// };
